var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendIconActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3841 0.917902C32.263 0.0908762 34.9188 2.74674 34.0919 5.62565L26.7837 31.066C25.5655 35.3065 19.9024 36.1124 17.5757 32.3761L14.3499 27.196C13.4576 25.7632 13.6737 23.9009 14.8711 22.7036L21.7566 15.8181C22.467 15.1075 22.469 13.9573 21.7607 13.2492C21.0526 12.541 19.9026 12.543 19.1919 13.2536L12.3066 20.139C11.1093 21.3363 9.24701 21.5524 7.8142 20.6602L2.63366 17.4341C-1.10255 15.1075 -0.296817 9.4443 3.94376 8.22611L29.3841 0.917902Z",
    fill: "#104145"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIconActive);
export default __webpack_public_path__ + "static/media/send-icon-active.82341dda664689c0a761bf51d012b0f4.svg";
export { ForwardRef as ReactComponent };